function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.673 3H7.446c-.672 0-.924.352-.399.87.693.685 1.512 1.514 2.772 2.591 0 0-5.691 3.503-4.704 9.266.987 5.741 7.791 6.446 7.959 5.679.189-.788-3.948-1.617-2.919-4.208 1.008-2.529 1.932-3.482 4.557-5.907 1.302 1.285 2.352 2.446 3.171 3.254.546.58.966.539.966-.249V4.036c0-.746-.315-1.036-1.176-1.036z"
});
const SvgIconDevIcShortcut = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref);
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconDevIcShortcut, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-dev-ic-shortcut.02428191.svg";
export { ForwardRef as ReactComponent };